import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";

const DocFormIsInvalidModal = props => (
  <Modal
    open
    onClose={() => props.togglePopUp("showDocFormIsInvalidModal", false)}
    closeOnOverlayClick={false}
    center>
    <div className="approvalpopup" id={props.popupID}>
      <div className="approvalpopup-header">
        <p>{props.title}</p>
      </div>
      <div className="approvalpopup-note">
        <p className="approvalpopup-workflows-heading">{props.subTitle}</p>
      </div>
    </div>
    <section className="createquotepopup-footer popup-footer clearfix">
      <div className="footer-actions">
        <Button
          className="btn btn-primary"
          onClick={() => props.togglePopUp("showDocFormIsInvalidModal", false)}
          data-test="docformisinvalidmodal-ok-btn">
          OK
        </Button>
      </div>
    </section>
  </Modal>
);

export default DocFormIsInvalidModal;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocFormIsInvalidModal.js